// ⚠️ all the export names need to be page content type id

import type { MapperOptions } from '#layers/core/types'
import mapperBlockCampaignsCallToAction from './blocks/block-campaigns-call-to-action/mapper-block-campaigns-call-to-action'
import mapperBlockIndexChapter from './blocks/block-index-chapter/mapper-block-index-chapter'
import mapperBlockIndexContentGroup from './blocks/block-index-content-group/mapper-block-index-content-group'
import mapperBlockIndexHighlight from './blocks/block-index-highlight/mapper-block-index-highlight'
import mapperBlockPartnerMetadata from './blocks/block-partner-metadata/mapper-block-partner-metadata'
import mapperBlockReportsList from './blocks/block-reports-list/mapper-block-reports-list'
import mapperBlockStory from './index-reports/block-story/mapper-block-story'
import mapperBlockTerminalSpecs from './blocks/block-terminal-specs/mapper-block-terminal-specs'
import { mapperPageIndexChapterShort } from './index-reports/page-index-chapter/mapper-page-index-chapter-short'
import { pageIndustryDetailGenericMapper } from './industries/mapper-page-industry-detail-generic-mapper'
import mapperPagePartnersDetailShort from './partners/mapper-page-partners-detail-short'
import mapperBlockManualContent from './manuals/mapper-block-manual-content'

import { mapperPageUpliftDetail } from './uplift/page-uplift-detail/mapper-page-uplift-detail'

export { mapperPageContactDetail as PageContactDetail } from '#layers/core/data-layer/pages/page-contact-detail/mapper-page-contact-detail'
export { mapperPageContactThankYou as PageContactThankYou } from '#layers/core/data-layer/pages/page-contact-thank-you/mapper-page-contact-thank-you'
export { mapperPageContact as PageContact } from '#layers/core/data-layer/pages/page-contact/mapper-page-contact'
export { default as PageLegalDetail } from './legal/page-legal-detail/mapper-page-legal-detail'
export { default as PageLegal } from './legal/page-legal/mapper-page-legal'

export { default as PageLicensesDetail } from './licenses/page-licenses-detail/mapper-page-licenses-detail'
export { default as PageLicenses } from './licenses/page-licenses/mapper-page-licenses'
export { default as PageInfrastructure } from './pages/page-infrastructure/mapper-page-infrastructure'
export { default as PagePrivacyPolicyDetail } from './pages/page-privacy-policy-detail/mapper-page-privacy-policy-detail'
export { default as PagePrivacyPolicy } from './pages/page-privacy-policy/mapper-page-privacy-policy'
export { default as PagePoliciesAndDisclaimerDetail } from './policies-and-disclaimer/page-policies-and-disclaimer-detail/mapper-page-policies-and-disclaimer-detail'
export { default as PagePoliciesAndDisclaimer } from './policies-and-disclaimer/page-policies-and-disclaimer/mapper-page-policies-and-disclaimer'

// Specific typemapper block/component only affecting main
// ex: EventLocation
export default {
  mapperBlockPartnerMetadata,
  mapperBlockReportsList,
  mapperBlockIndexChapter,
  mapperBlockIndexContentGroup,
  mapperBlockIndexHighlight,
  mapperBlockStory,
  mapperPageIndexChapterShort,
  mapperBlockCampaignsCallToAction,
  mapperBlockTerminalSpecs,
  mapperBlockManualContent
}

export const TypeMapper = {
  // EventLocation: (data: any, options: MapperOptions) => mapperEventLocation(data, options),
  BlockCampaignsCallToAction: (data: any, options: MapperOptions) => mapperBlockCampaignsCallToAction(data, options),
  BlockIndexHighlight: (data: any, options: MapperOptions) => mapperBlockIndexHighlight(data, options),
  BlockReportsList: (data: any, options: MapperOptions) => mapperBlockReportsList(data, options),
  PageIndustrySubscriptionPayments: (data: any, options: MapperOptions) =>
    pageIndustryDetailGenericMapper(data, options),
  PageIndustryDigitalPayments: (data: any, options: MapperOptions) => pageIndustryDetailGenericMapper(data, options),
  PageIndustryMobilityPayments: (data: any, options: MapperOptions) => pageIndustryDetailGenericMapper(data, options),
  PageIndustryRetailPayments: (data: any, options: MapperOptions) => pageIndustryDetailGenericMapper(data, options),
  PageIndustryHotelPayments: (data: any, options: MapperOptions) => pageIndustryDetailGenericMapper(data, options),
  PageIndustryFoodBeveragePayments: (data: any, options: MapperOptions) =>
    pageIndustryDetailGenericMapper(data, options),
  PageIndustrySaasPlatforms: (data: any, options: MapperOptions) => pageIndustryDetailGenericMapper(data, options),
  PageUpliftDetail: (data: any, options: MapperOptions) => mapperPageUpliftDetail(data, options),
  PagePartnersDetail: (data: any, options: MapperOptions) => mapperPagePartnersDetailShort(data, options),
  BlockPartnerMetadata: (data: any, options: MapperOptions) => mapperBlockPartnerMetadata(data, options),
  BlockPartnerMetadataLazy: (data: any) => data,
  BlockIndexContentGroup: (data: any, options: MapperOptions) => mapperBlockIndexContentGroup(data, options),
  BlockIndexChapter: (data: any, options: MapperOptions) => mapperBlockIndexChapter(data, options),
  BlockStory: (data: any, options: MapperOptions) => mapperBlockStory(data, options),
  BlockTerminalSpecs: (data: any) => mapperBlockTerminalSpecs(data),
  BlockTerminalSpecsLazy: (data: any) => data,
  PageIndexChapter2025: (data: any, options: MapperOptions) => mapperPageIndexChapterShort(data, options),
  BlockManualContent: (data: any, options: MapperOptions) => mapperBlockManualContent(data, options)
}
